"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _WalletService_rpcService, _WalletService_paymasterService;
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalletService = void 0;
const accounts_1 = require("viem/accounts");
const EoaWallet_1 = require("./EoaWallet");
const Helpers_1 = require("./Helpers");
const WalletFactory_1 = require("./WalletFactory");
const KernelSmartWallet_1 = require("./smart-wallet/KernelSmartWallet");
class WalletService {
    constructor(rpcService, paymasterService) {
        _WalletService_rpcService.set(this, void 0);
        _WalletService_paymasterService.set(this, void 0);
        this.createSmartWallet = async (exportedWallet, config) => {
            const initialRpc = await __classPrivateFieldGet(this, _WalletService_rpcService, "f").getOrCreate({
                chainId: config.chainId,
            });
            const transientWallet = await KernelSmartWallet_1.KernelSmartWallet.create({
                kernel: {
                    ...exportedWallet.kernel,
                    rpcUrl: initialRpc.url,
                },
            });
            const walletRpc = await __classPrivateFieldGet(this, _WalletService_rpcService, "f").getOrCreate({
                chainId: config.chainId,
                wallet: transientWallet.address,
            });
            const paymasterUrl = !config.paymaster?.disabled
                ? (await __classPrivateFieldGet(this, _WalletService_paymasterService, "f").getOrCreate({
                    chainId: config.chainId,
                    entryPoint: transientWallet.entryPoint,
                    wallet: transientWallet.address,
                })).url
                : undefined;
            return WalletFactory_1.WalletFactory.from({
                kernel: {
                    rpcUrl: walletRpc.url,
                    paymasterUrl,
                    ...(0, Helpers_1.exportSource)(exportedWallet.kernel),
                },
            });
        };
        this.createEoaWallet = async (exportedWallet, config) => {
            const initialRpc = await __classPrivateFieldGet(this, _WalletService_rpcService, "f").getOrCreate({
                chainId: config.chainId,
            });
            const address = await EoaWallet_1.EoaWallet.computeAddress(exportedWallet, initialRpc.url);
            const walletRpc = await __classPrivateFieldGet(this, _WalletService_rpcService, "f").getOrCreate({
                chainId: config.chainId,
                wallet: address,
            });
            return WalletFactory_1.WalletFactory.from({
                eoa: {
                    rpcUrl: walletRpc.url,
                    ...(0, Helpers_1.exportSource)(exportedWallet.eoa),
                },
            });
        };
        __classPrivateFieldSet(this, _WalletService_rpcService, rpcService, "f");
        __classPrivateFieldSet(this, _WalletService_paymasterService, paymasterService, "f");
    }
    generate(config) {
        if (config.type === 'eoa') {
            return this.createEoaWallet({
                version: '1.0',
                eoa: {
                    mnemonic: (0, accounts_1.generateMnemonic)(accounts_1.english),
                },
            }, config);
        }
        return this.createSmartWallet({
            version: '1.0',
            kernel: {
                privateKey: (0, accounts_1.generatePrivateKey)(),
            },
        }, config);
    }
    from(exportedWallet, config) {
        if ('eoa' in exportedWallet) {
            return this.createEoaWallet(exportedWallet, config);
        }
        return this.createSmartWallet(exportedWallet, config);
    }
}
exports.WalletService = WalletService;
_WalletService_rpcService = new WeakMap(), _WalletService_paymasterService = new WeakMap();
